import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import RoutingThreadFilterGroup
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu/components/RoutingThreadFilterGroup';
import {
  OtherThreadFilterGroup,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu/components/OtherThreadFilterGroup';
import { FDStack } from '@facet-wealth/design';
import {
  FrequentlyUsedFilterGroup,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu/components/FrequentlyUsedFilterGroup';
import {
  MESSAGE_ROUTE_STATUS_QUERY_FIELD,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';

const AgentThreadFilterMenu = ({
  resource, onChange, handleClose,
}) => {
  const hasThreadRoutingFilters = resource.meta().field(MESSAGE_ROUTE_STATUS_QUERY_FIELD)?.options()?.list().length > 0;

  return (
    <FDStack direction={'column'} spacing={3} padding={3}>
      <FrequentlyUsedFilterGroup resource={resource} onChange={onChange} handleClose={handleClose} />
      { hasThreadRoutingFilters ? <RoutingThreadFilterGroup resource={resource} onChange={onChange} handleClose={handleClose} /> : null}
      <OtherThreadFilterGroup resource={resource} onChange={onChange} handleClose={handleClose} showTitle={hasThreadRoutingFilters} />
    </FDStack>
  );
};

AgentThreadFilterMenu.defaultProps = {
};

AgentThreadFilterMenu.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  handleClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export {
  AgentThreadFilterMenu,
};
